import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import { Field, Form, Formik } from "formik";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";

import CloseModal from "../../../components/icons/CloseModal";
import { SocketContext } from "../../../context/socket";

const SocialMediaCaption = (props) => {
  const { webhookSocket } = useContext(SocketContext);
  const { entityId } = useOutletContext();
  const { captionModal, setCaptionModal, createSocialMediaCaption, clip, loder, setLoder, streamDetails } = props;
  const [initialState, setInitialState] = useState({
    caption: "",
    title: "",
  });
  const [caption, setCaption] = useState("");
  const [socketUpdate, setSocketUpdate] = useState({});
  const [title, setTitle] = useState("");

  useEffect(() => {
    setCaption(clip.social_media_caption);
    setTitle(clip.social_media_title);
  }, [clip]);

  const closeModal = () => {
    setCaptionModal(false);
    setInitialState({
      caption: "",
      title: "",
    });
  };

  const handleSubmit = async () => {
    try {
      setLoder(true);
      const { value } = await createSocialMediaCaption(clip);
      if (value.status) {
        notification["success"]({ message: value.message });
      } else {
        notification["error"]({ message: value.message });
        setLoder(false);
      }
    } catch (error) {
      setLoder(false);
      console.log({ error });
    }
  };
  useEffect(() => {
    webhookSocket.on(`socialMediaCaption${streamDetails?.entityId}`, (data) => {
      //call socket use effect here
      setSocketUpdate({
        entityId: data?.entityId,
        data: data,
        status: data?.status || false,
      });
    });
  }, []);
  useEffect(() => {
    if (socketUpdate.status) {
      setLoder(false);
      setCaption(_.get(socketUpdate?.data, "socialMediaCaption", ""));
      setTitle(_.get(socketUpdate?.data, "socialMediaTitle", ""));
    }
  }, [socketUpdate]);

  return (
    <>
      <Modal
        isOpen={captionModal}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Generate Social Media Caption</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialState} onSubmit={handleSubmit}>
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="field-items mb-4">
                      <label className="form-label">Title</label>
                      <Field className="form-control" name="title" value={title} type="text" disabled={true} />
                    </div>
                  </div>
                </div>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="field-items mb-4">
                      <label className="form-label">Caption</label>
                      <Field className="form-control" name="caption" value={caption} type="text" disabled={true} />
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button className="btn btn-primary" type="submit">
                        {!caption ? "Generate Caption" : "Regenerate Caption"}
                      </button>
                      {loder && (
                        <Spin
                          size="large"
                          indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                          className="loader__full"
                        ></Spin>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </>
  );
};

export default SocialMediaCaption;
